import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Sidebar from "../../components/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import UserListComponent from "../../components/UserList";
import * as modalActions from "../../redux/actions/modalActions";
import * as commonActions from "../../redux/actions/commonAction";
import * as userAuthActions from "../../redux/actions/userAuthAction";
import { setLanguage } from "redux-i18n";
import { ShowForPermission } from "../../components/UserAuth/ShowForPermissionComponent";
import { PERMISSION_TYPE, PERMISSON_MODULES } from "../../Permission.config";

const UserList = (props, context) => {

    const profileReducer = useSelector((state) => state.profileReducer);
    const commonReducer = useSelector((state) => state.commonReducer);
    const userAuthReducer = useSelector((state) => state.userAuthReducer);

    const dispatch = useDispatch();
    const modalAction = bindActionCreators(modalActions, dispatch);
    const commonAction = bindActionCreators(commonActions, dispatch);
    const userAuthAction = bindActionCreators(userAuthActions, dispatch);

    const setSelectedCompany = (companyInfo) => {
        userAuthAction.resetSelectedCompany(companyInfo);
    }

    const resetDomainList = (domainList) => {
        userAuthAction.resetDomainList(domainList);
    }

    const uploadFileForUserData = (fileData) => userAuthAction.uploadFileForUserData(fileData);


    const getAllAuthUsers = (companyId, pageNo, pageSize, searchValue, searchColumn, sortColumn, sortOrder, roleId) => {
        let payload;
        if(roleId==0){
             payload = {
                "request": {
                    "companyId": companyId,
                    "pagination": {
                        "pageNo": searchValue ? 1 : pageNo,
                        "pageSize": pageSize,
                        "sortColumn": null,
                        "sortOrder": null,
                        "searchColumn": null,
                        "searchValue": searchValue
                    },
                    //  "roleId": roleId,
                    "onlyBrokerAndAdmin": !companyId?true:false
                }
            }
        }
        else{
             payload = {
                "request": {
                    "companyId": companyId,
                    "pagination": {
                        "pageNo": searchValue ? 1 : pageNo,
                        "pageSize": pageSize,
                        "sortColumn": null,
                        "sortOrder": null,
                        "searchColumn": null,
                        "searchValue": searchValue
                    },
                     "roleId": roleId,
                    "onlyBrokerAndAdmin": !companyId?true:false
                }
            }
        }
        
        companyId && userAuthAction.getAuthUserRoles(companyId);
        userAuthAction.getAllAuthUsers(companyId, payload);
    }

    const deleteUserById = (authUserId) => {
        userAuthAction.deleteUserById(authUserId, true);
    }

    const resetIsUserDelete = (authUserId) => {
        userAuthAction.resetIsUserDelete();
    }

    //for open modal
    const openSetModal = (children, size) => {
        modalAction.openSetModal(children, size);
    };

    //for closing modal
    const closeRemoveModal = () => {
        modalAction.closeRemoveModal();
    };

    //for changing language
    const languageChange = (language) => {
        dispatch(setLanguage(language));
    };

    const onMenuToggle = (isOpen) => {
        commonAction.setIsSideMenuOpen(isOpen);
    };

    const changeTerminationStatus = (authUserId, terminationStatus) => {
        userAuthAction.changeTerminationStatus(authUserId, terminationStatus);
    }

    const changeLockStatus = (authUserId, lockStatus) => {
        userAuthAction.changeLockStatus(authUserId, lockStatus)
    }

    const getAllCompanyList = () => userAuthAction.getAllCompanyList();

    const getAllDomainList = (selectedCompany) => userAuthAction.getAllDomainList(selectedCompany);

    const getCompanyServiceSettings = (selectedCompany) => userAuthAction.getCompanyServiceSettings(selectedCompany);

    const saveCompanyServiceSetting = (serviceData, selectedCompany) => userAuthAction.saveCompanyServiceSetting(serviceData, selectedCompany);

    const resetDomainFlag = (domainFlag) => userAuthAction.resetDomainFlag(domainFlag);

    const resetTotalRecordOfUserList = (totalRecord) => userAuthAction.resetTotalRecordOfUserList(totalRecord);

    const checkIsUserAssignAsBackup = (authUserId) => userAuthAction.checkIfUserAssignAsBackup(authUserId);

    const resetIsUserAssignAsBackup = () => userAuthAction.resetIsBackupAssigned();

    const resetsuccessMessageForBackupUserAssigned = () => userAuthAction.resetsuccessMessageForBackupUserAssigned();

    const resetOpenSimpleModalForTermiantion = () => userAuthAction.resetOpenSimpleModalForTermiantion();

    const getAuthUserRoles = (companyId) => userAuthAction.getAuthUserRoles(companyId);

    const getFileHistory = (fileLevel) => {
        commonAction.getFileHistory(fileLevel, userAuthReducer.selectedCompany);
    }

    return (
        <>
            {window.location.hash !== "#/" && (
                <Sidebar
                    languageChange={languageChange}
                    openSetModalAction={openSetModal}
                    closeRemoveModal={closeRemoveModal}
                    managersDetails={profileReducer.managersDetails}
                    onMenuToggle={onMenuToggle}
                    isSideMenuOpen={commonReducer.isSideMenuOpen}
                    context={context}
                />
            )}
            <div className="Content-Panel">
                <div className="Dashboard-Content">
                    <ShowForPermission module={PERMISSON_MODULES.USERS} permission={PERMISSION_TYPE.VIEW}>
                        <UserListComponent
                            userAuthReducer={userAuthReducer}
                            getAllAuthUsers={getAllAuthUsers}
                            deleteUserById={deleteUserById}
                            resetIsUserDelete={resetIsUserDelete}
                            changeTerminationStatus={changeTerminationStatus}
                            changeLockStatus={changeLockStatus}
                            openSetModalAction={openSetModal}
                            closeRemoveModal={closeRemoveModal}
                            {...props}
                            context={context}
                            getAllCompanyList={getAllCompanyList}
                            setSelectedCompany={setSelectedCompany}
                            getAllDomainList={getAllDomainList}
                            getCompanyServiceSettings={getCompanyServiceSettings}
                            saveCompanyServiceSetting={saveCompanyServiceSetting}
                            resetDomainFlag={resetDomainFlag}
                            resetTotalRecordOfUserList={resetTotalRecordOfUserList}
                            resetDomainList={resetDomainList}
                            uploadFileForUserData={uploadFileForUserData}
                            checkIsUserAssignAsBackup={checkIsUserAssignAsBackup}
                            resetIsUserAssignAsBackup={resetIsUserAssignAsBackup}
                            resetsuccessMessageForBackupUserAssigned={resetsuccessMessageForBackupUserAssigned}
                            resetOpenSimpleModalForTermiantion={resetOpenSimpleModalForTermiantion}
                            getAuthUserRoles={getAuthUserRoles}
                            getFileHistory={getFileHistory}
                        />
                    </ShowForPermission>
                </div>
            </div>
        </>
    );
};

UserList.contextTypes = {
    t: PropTypes.func.isRequired,
};
export default UserList;
